import React from 'react';
import { connect } from 'react-redux';
import { Divider, Loader } from 'semantic-ui-react';
import { findMatch } from '@/utils/resultsHelper';
import UserDefinedAttachmentLink from './UserDefinedAttachmentLink';
import UserDefinedAttachmentIcon from '../components/UserDefinedAttachmentIcon';

const UserDefinedAttachmentRestrictionInfo = ({ datasetCondition, code, isDownloading }) => (
  <>
    <UserDefinedAttachmentLink code={code} datasetCondition={datasetCondition}>
      <UserDefinedAttachmentIcon datasetCondition={datasetCondition} />
      {datasetCondition.context.attachmentName}
    </UserDefinedAttachmentLink>
    {isDownloading && <Loader active="visible" inline size="mini" className="ml-5 mb-2" />}
    {datasetCondition.context.text && <Divider inverted />}
  </>
);

const mapStateToProps = ({
  datasetConditions: {
    attachments: {
      downloadsInProgress,
    },
  },
}, { datasetCondition }) => ({
  isDownloading: !!findMatch(downloadsInProgress, datasetCondition.id, 'id'),
});

export default connect(mapStateToProps)(UserDefinedAttachmentRestrictionInfo);
